var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Account',{staticClass:"my-10"}),(_vm.stripeAccount)?_c('div',[(_vm.isCompany)?_c('Persons',{staticClass:"my-10",attrs:{"id":_vm.stripeAccount.id}}):_vm._e(),_c('Banks',{staticClass:"my-10",attrs:{"id":_vm.stripeAccount.id}}),_c('Payouts',{staticClass:"my-10",attrs:{"id":_vm.stripeAccount.id}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }